import { useToastStore, type ToastOptions } from './toast.store';

// Imperative API callable from any context (event handlers, mutation callbacks,
// non-React code). Bypasses React subscription so it never re-renders the caller.
export const toast = {
  success: (message: string, options?: ToastOptions) =>
    useToastStore.getState().push('success', message, options),
  error: (message: string, options?: ToastOptions) =>
    useToastStore.getState().push('error', message, options),
  warning: (message: string, options?: ToastOptions) =>
    useToastStore.getState().push('warning', message, options),
  info: (message: string, options?: ToastOptions) =>
    useToastStore.getState().push('info', message, options),
};
